import { useBrandConfig } from '~/config/branding';
import { FEATURES_CONTENT } from './featuresContent';

export const FeaturesPage = () => {
  const { brand } = useBrandConfig();
  const { eyebrow, headline, features, screenshot } = FEATURES_CONTENT[brand];
  return (
    <div className="text-left min-h-screen bg-white">
      <div className="py-10 sm:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:items-center">
            <div className="lg:pr-8">
              <div className="lg:max-w-lg">
                <h2 className="text-base/7 font-semibold text-primary-50">{eyebrow}</h2>
                <p className="mt-2 text-4xl font-semibold tracking-tight text-grey-100 sm:text-5xl">
                  {headline}
                </p>
                <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-grey-300 lg:max-w-none">
                  {features.map((feature) => (
                    <div key={feature.name} className="relative pl-9">
                      <dt className="inline font-semibold text-grey-100">
                        <feature.icon
                          aria-hidden="true"
                          className="absolute top-1 left-1 size-5 text-primary-50"
                        />
                        {feature.name}
                      </dt>{' '}
                      <dd className="inline">{feature.description}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
            <img
              alt={screenshot.alt}
              src={screenshot.src}
              width={2048}
              height={1360}
              className="h-auto w-full max-w-full rounded-xl ring-1 shadow-xl ring-grey-100/10"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
